import { UpdatePaymentApiAccountsListApi } from "@/features/accounts/payment/api/services/update-accounts-list-api";
import { UpdatePaymentApiAccountsListRequestModel } from "@/features/accounts/payment/api/services/update-accounts-list-model";

/// MoneyLook 口座更新処理(LookAPI版)
export class UpdatePaymentApiAccountsListService {
  private updatePaymentApiAccountsListApi = new UpdatePaymentApiAccountsListApi();

  /**
   * MoneyLook 口座更新API(LookAPI版)実行
   */
  public async updatePaymentAccountsList(param: UpdatePaymentApiAccountsListRequestModel) {
    return await this.updatePaymentApiAccountsListApi.updatePaymentApiAccountsList(param);
  }
}